// ── Design decisions ──
// Chips de estado de una sola línea, todos del mismo tamaño (text-[10px],
// rounded-full) para que puedan convivir en la misma tira sin saltos de
// altura. Colores: violeta = IA, slate = manual/borrador, verde = cerrado,
// ámbar = falta algo (sin bulto / sin cliente / sin tipo / requiere revisión).
// Ninguno es interactivo: son señales, no controles.
//
// `ambiance` (sólo lo pide el ExtractionDrawer) cambia la piel de ProvenanceChip
// y ReviewDot por los tokens de ambiance.css. SinClienteChip / SinBultoChip NO
// tienen esa variante a propósito: su píldora ámbar queda igual en todas las
// superficies, panel de la foto incluido.

import { tipoIngresoLabel } from './labels';

const base =
  'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold leading-4';

const AMBAR = `${base} border-amber-300 bg-amber-50 text-amber-700`;

export const ProvenanceChip = ({ source, ambiance = false }) => {
  if (ambiance) {
    return source === 'ai' ? (
      <span className="amb-chip amb-chip--ia" title="Extraído por IA">
        IA
      </span>
    ) : (
      <span className="amb-chip amb-chip--manual" title="Ingresado a mano">
        Manual
      </span>
    );
  }
  return source === 'ai' ? (
    <span className={`${base} border-violet-300 bg-violet-50 text-violet-700`} title="Extraído por IA">
      IA
    </span>
  ) : (
    <span className={`${base} border-slate-200 bg-slate-50 text-slate-600`} title="Ingresado a mano">
      Manual
    </span>
  );
};

export const ReviewDot = ({ visible, ambiance = false }) =>
  visible ? (
    <span
      role="img"
      aria-label="Requiere revisión"
      title="Requiere revisión"
      className={ambiance ? 'amb-dot' : 'inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-amber-500'}
    />
  ) : null;

export const EstadoChip = ({ status }) =>
  status === 'cerrado' ? (
    <span className={`${base} border-green-300 bg-green-50 text-green-700`}>Cerrado</span>
  ) : (
    <span className={`${base} border-slate-200 bg-slate-50 text-slate-600`}>Borrador</span>
  );

export const SinBultoChip = () => <span className={AMBAR}>Sin bulto</span>;

export const SinClienteChip = () => <span className={AMBAR}>Sin cliente</span>;

// Cliente asignado por coincidencia exacta e inequívoca del nombre leído.
// Neutro a propósito (no ámbar): es información, no un bloqueo; tocar el
// selector lo apaga.
export const AutoAsignadoChip = () => (
  <span
    className={`${base} border-slate-200 bg-slate-50 text-slate-500`}
    title="Cliente asignado automáticamente por coincidencia exacta del nombre leído — tocá el selector para cambiarlo"
  >
    Auto-asignado
  </span>
);

export const TipoIngresoChip = ({ value }) =>
  value ? (
    <span className={`${base} border-slate-200 bg-white text-slate-700`}>{tipoIngresoLabel(value)}</span>
  ) : (
    <span className={AMBAR}>Sin tipo</span>
  );
